<!-- Left Actions Container -->
<div class="flex flex-col h-[calc(92vh-65px)] justify-between">

    <!-- Top Section - Compose and Actions -->
    <div class="space-y-3">

        <!-- Compose Button -->
        <div *ngIf="!updateDraft">
            <p-button label="Compose" icon="pi pi-plus"
                styleClass="w-full p-button-lg p-button-success p-button-raised shadow-lg hover:shadow-xl transition-all duration-300 mb-3"
                (onClick)="openBottomSheet()" [text]="isSmallScreen">
                <span *ngIf="isSmallScreen" class="sr-only">Compose</span>
            </p-button>
        </div>

        <!-- Action Menu Items -->
        <div class="space-y-5 mt-5">
            <div *ngFor="let action of actions"
                class="w-full flex items-center justify-start text-left border rounded-md cursor-pointer transition-all duration-200 pl-2 py-3"
                [ngClass]="{
      'bg-blue-50 border-blue-300 text-blue-700 shadow-sm': activeAction === action.action,
      'bg-white border-gray-300 text-gray-700 hover:bg-gray-50': activeAction !== action.action
    }" (click)="setActiveAction(action.action)" pTooltip="{{ isSmallScreen ? action.label : '' }}"
                tooltipPosition="right">
                <!-- Icon -->
                <i class="pi pi-{{ getPrimeIcon(action.icon) }} ml-3 mr-2"></i>

                <!-- Label (only if not small screen) -->
                <span *ngIf="!isSmallScreen">{{ action.label }}</span>
            </div>
        </div>

    </div>

    <!-- Bottom Section - Revoke Access -->
    <div class="mt-8">
        <p-button label="Revoke Access" icon="pi pi-times-circle"
            styleClass="w-full p-button-danger p-button-outlined hover:shadow-md transition-all duration-200"
            (onClick)="handlOpenRevokeAccessModal()" [text]="isSmallScreen"
            [pTooltip]="isSmallScreen ? 'Revoke Access' : ''" tooltipPosition="right">
            <span *ngIf="isSmallScreen" class="sr-only">Revoke Access</span>
        </p-button>
    </div>
</div>

<!-- Revoke Access Confirmation Dialog -->
<p-dialog header="Revoke Access" appendTo="body"
[modal]="true" [(visible)]="showRevokeDialog" [breakpoints]="{ '1199px': '65vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '45vw' }" [draggable]="false" [resizable]="false">

    <!-- Dialog Content -->
    <div class="p-6">
        <!-- Warning Icon -->
        <div class="flex items-start gap-4">
            <div class="flex-shrink-0">
                <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                    <i class="pi pi-exclamation-triangle text-red-600 text-xl"></i>
                </div>
            </div>

            <!-- Message Content -->
            <div class="flex-1">
                <h3 class="text-lg font-semibold text-gray-900 mb-3">
                    Are you sure you want to revoke access?
                </h3>
                <div class="space-y-2 text-gray-600">
                    <p>This action will disconnect your account from the Sales Mail Hub.</p>
                    <p class="text-sm bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded">
                        <strong>Note:</strong> You'll need to reconnect your account to access emails again.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Dialog Footer -->
    <ng-template pTemplate="footer">
        <div class="flex gap-3 justify-end">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text p-button-secondary"
                (onClick)="closeRevokeDialog()">
            </p-button>

            <p-button label="Revoke Access" icon="pi pi-times-circle" styleClass="p-button-danger p-button-raised"
                [loading]="btnLoading"  (onClick)="confirmRevokeAccess()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Alternative: Confirm Dialog (Simpler approach) -->
<!-- 
<p-confirmDialog 
  header="Revoke Access"
  icon="pi pi-exclamation-triangle"
  acceptButtonStyleClass="p-button-danger"
  rejectButtonStyleClass="p-button-text p-button-secondary"
  acceptLabel="Revoke Access"
  rejectLabel="Cancel">
</p-confirmDialog>
-->

<!-- Bottom Sheet for Mobile Compose (if needed) -->
<p-drawer [(visible)]="showComposeSheet" position="bottom" styleClass="h-96" [showCloseIcon]="true">

    <ng-template pTemplate="header">
        <div class="flex items-center gap-2">
            <i class="pi pi-envelope text-xl"></i>
            <span class="font-semibold">Compose Email</span>
        </div>
    </ng-template>

    <!-- Compose form content would go here -->
    <div class="p-4">
        <p class="text-gray-600">Compose form will be implemented here...</p>
    </div>
</p-drawer>